import React from 'react';
import * as PropTypes from 'prop-types';
import { bodyTdStyles, bodyTrStyles, firstBodyTdStyles, tableStyles, theadStyles } from './styles/Table.css';
import LwolfLink from './../../common/LwolfLink';
import IconButton from '../../common/IconButton';
import TableHeader from './TableHeader';
import { ColorEnum } from '../../../constants/Enums';


const GroupTable = props => {
    const getTableRows = () => {
        return props.rows.map((row, index) => {
            let buttonDisabled = row.roleType != null;
            let tds = [];
            let i = 0;
            for (let prop in row) {
                if (i === 0) {
                    tds.push(
                        <td style={firstBodyTdStyles} key={i}>
                            <strong>
                                <LwolfLink
                                    to={`/security-groups/${row.id}`}
                                    text={row[prop]}
                                    tooltipText={row['description']}
                                />
                            </strong>
                        </td>
                    );
                } else if (prop !== 'id' && prop !== 'roleType' && prop !== 'description') {
                    tds.push(<td style={bodyTdStyles} key={i}>{row[prop]}</td>);
                }
                i++;
            }
            tds.push(
                <td style={bodyTdStyles} key={i}>
                    <div className="float-right">
                        <IconButton iconType="content_copy" additionalStyles={{ marginRight: '1em' }}
                                    action={() => props.copySecurityGroup(row.id)} />
                        <IconButton iconType="delete" additionalStyles={{ marginRight: '.5em' }}
                                    action={() => props.deleteSecurityGroup(row.id)} disabled={buttonDisabled} />
                    </div>
                </td>);

            return (
                <tr style={bodyTrStyles} key={index}>
                    {tds}
                </tr>
            );
        });
    };

    const getTableHeaders = () => {
        let headers = [];

        props.headers.forEach((header, i) => {
            const borderColor = ColorEnum[i];
            headers.push(
                <TableHeader key={i} sortTarget={header.target} isFirstElement={i === 0} title={header.title}
                             sort={props.sort} borderColor={borderColor} />
            );
        });

        headers.push(<th key={44} />);
        return headers;
    };

    return (
        <table className="table" style={tableStyles}>
            <thead style={theadStyles}>
                <tr>
                    {getTableHeaders()}
                </tr>
            </thead>
            <tbody>
                {getTableRows()}
            </tbody>
        </table>
    );
};

GroupTable.propTypes = {
    //Array of objects -- title and target
    //Title will be displayed
    //Target represents field to be sorted on click
    headers: PropTypes.array.isRequired,
    //Array of objects -- the name of each cell should match the 'target' field of the headers object
    rows: PropTypes.array.isRequired,
    //Function to sort permissions on header click
    sort: PropTypes.func.isRequired,
    //Delete role when button is pressed
    deleteSecurityGroup: PropTypes.func.isRequired,
    //Copy security group's permission structure
    copySecurityGroup: PropTypes.func.isRequired
};

export default GroupTable;